var labelLocalizer = {
  label: null,
  callbacks: [],
  fetching: false,
  getLocalizedLabel: function (callback) {
    if (this.label) return callback(this.label);
    else this.callbacks.push(callback);

    if (!this.fetching) {
      this.fetching = true;
      fetch(window.Shopify.routes.root + "?sections=omnibus-price-sale-locale")
        .then(function (response) {
          return response.json();
        })
        .then(
          function (response) {
            this.label = response;
            while (this.callbacks.length) {
              this.callbacks.pop()(this.label);
            }
          }.bind(this)
        );
    }
  },
};

function makeOmnibusLabel(productHandle, omnibusPrice) {
  return function (data) {
    var el = jQuery(data["omnibus-price-sale-locale"]);

    el.attr("id", `omnibus-price-${productHandle}`);
    var p = el.children("p");
    p.text(p.text() + " " + omnibusPrice + "€");
    jQuery(`#omnibus-placeholder-${productHandle}`).append(el);
  };
}

function onLoadOmnibusPrice(productHandle, omnibusPrice) {
  labelLocalizer.getLocalizedLabel(
    makeOmnibusLabel(productHandle, omnibusPrice)
  );
}

// Override Settings
if (typeof boostPFSConfig !== "undefined") {
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: true,
      refineByStyle: "style2",
      filterTreeMobileIcon:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><path d="M48 42h10M48 42a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM7 42h31M16 22H6M16 22a5 5 0 1 1 5 5 5 5 0 0 1-5-5zM57 22H26"></path></svg>',
    },
    selector: {
      avoidStickyHeader:
        ".site-header, .site-header--opening, #shopify-section-header",
    },
  };
}

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    firstVariant = {},
    boostPFSImgDefaultSrc =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    boostPFSRangeWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048,
    ];

  BoostPFS.inject(this);
  // boostPFSFilterConfig.general.separateRefineByFromFilter = (jQ('.boost-pfs-filter-tree-h').length && !Utils.isMobile() > 0 && boostPFSConfig.custom.filter_tree_horizontal_style != 'style-expand') ? true : false;

    /*** Omnibus logics ***/
  function isOnOmnibusSale(data, onSale) {
    var priceMin = data.price_min;
    var compareAtPriceMin = data.compare_at_price_min;
    var sizeGroups = getSizeGroup(data) || [];
    var preparedData = getPreparedData(data, sizeGroups, true) || {};
    var availableSizeGroups = preparedData.availableSizeGroups || [];
    var prices = preparedData.prices || {};
    if (priceVaries && sizeGroups.length > 1) {
      if (availableSizeGroups.length > 0) {
        if (
          availableSizeGroups[0] !== sizeGroups[0] &&
          prices[availableSizeGroups[0]].compare_at_price !== compareAtPriceMin
        ) {
          compareAtPriceMin = prices[availableSizeGroups[0]].compare_at_price;
        }
        if (
          availableSizeGroups[0] !== sizeGroups[0] &&
          prices[availableSizeGroups[0]].price !== priceMin
        ) {
          priceMin = prices[availableSizeGroups[0]].price;
        }
      }
    }

    const omnibusPrice = data?.metafields
      ?.filter((el) => el.namespace === "omnibus")
      .filter((el) => el.key === "bestPrice")?.[0];

    if (omnibusPrice && onSale) {
      const omnibusPriceValue = JSON.parse(omnibusPrice.value);

      if (parseFloat(omnibusPriceValue.amount) <= priceMin) {
        onSale = false;
      }
    }

    return onSale;
  }

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    return data;
  }

  function buildImages(data) {
    var html = "",
      aspectRatio = "",
      rangeWidths = boostPFSRangeWidths,
      paddingTop = 100,
      thumb = boostPFSConfig.general.no_image_url;

    if (images.length > 0) {
      aspectRatio = images[0]["width"] / images[0]["height"];
      paddingBottom = 100 / aspectRatio;
      thumb = images[0];
    }
    var productGridImageFillClass = "";
    if (
      boostPFSConfig.custom.hasOwnProperty("product_grid_image_fill") &&
      boostPFSConfig.custom.product_grid_image_fill
    ) {
      productGridImageFillClass = "grid__image-contain";
    }

    if (boostPFSConfig.custom.product_grid_image_size == "natural") {
      html +=
        '<div class="image-wrap" style="height: 0; padding-bottom: ' +
        paddingBottom +
        '%;">';
      html +=
        "<img " +
        'class="grid-product__image lazyload" ' +
        'data-src="' +
        Utils.getFeaturedImage(images, "{width}x") +
        '" ' +
        'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
        'data-aspectratio="' +
        aspectRatio +
        '" ' +
        'data-sizes="auto" ' +
        'alt="' +
        data.title +
        '">';
      html +=
        "<noscript>" +
        '<img class="grid-product__image lazyloaded" ' +
        'src="' +
        Utils.getFeaturedImage(images, "400x") +
        '" ' +
        'alt="' +
        data.title +
        '">' +
        "</noscript>";
      html += "</div>";
    } else {
      html +=
        '<div class="grid__image-ratio grid__image-ratio--' +
        boostPFSConfig.custom.product_grid_image_size +
        '" >';
      html +=
        "<img " +
        'class="lazyload ' +
        productGridImageFillClass +
        '" ' +
        'data-src="' +
        Utils.getFeaturedImage(images, "{width}x") +
        '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' +
        aspectRatio +
        '" ' +
        'data-sizes="auto" ' +
        'alt="' +
        data.title +
        '">';
      html += "</div>";
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        html += '<div class="grid-product__secondary-image small--hide">';
        html +=
          '<img class="lazyload"' +
          'data-src="' +
          Utils.optimizeImage(images[1].src, "{width}x") +
          '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' +
          aspectRatio +
          '"' +
          'data-sizes="auto"' +
          'alt="' +
          data.title +
          '">';
        html += "</div>";
      }
    }

    return html;
  }
  function orderSizeGroups(order, value) {
    var ordering = {};
    for (var i = 0; i < order.length; i++) ordering[order[i]] = i;

    return value.sort(function (a, b) {
      return ordering[a] - ordering[b] || a.localeCompare(b);
    });
  }
  function getSizeGroup(data) {
    var sizes = data.options_with_values.find((o) => o.name === "size")?.values;
    var sizeGroups = [];
    for (let i = 0; i < sizes.length; i++) {
      var group = sizes[i].title?.split(" | ")[0];
      if (sizeGroups.indexOf(group) === -1) {
        sizeGroups.push(group);
      }
    }
    return sizeGroups;
  }
  function getPreparedData(data, sizeGroups, withPrice) {
    var availableSizeGroups = [];
    var prices = {};
    for (let i = 0; i < data.variants.length; i++) {
      for (let x = 0; x < sizeGroups.length; x++) {
        if (
          data.variants[i].title.includes(sizeGroups[x]) &&
          data.variants[i].inventory_quantity &&
          availableSizeGroups.indexOf(sizeGroups[x]) === -1
        ) {
          availableSizeGroups.push(sizeGroups[x]);
          if (withPrice) {
            prices[sizeGroups[x]] = {
              compare_at_price: Math.round(data.variants[i].compare_at_price),
              price: Math.round(data.variants[i].price),
            };
          }
        }
      }
    }
    availableSizeGroups = orderSizeGroups(sizeGroups, availableSizeGroups);
    return withPrice ? { prices, availableSizeGroups } : availableSizeGroups;
  }

  function buildPrice(data) {
    var html = "";

    // if (boostPFSConfig.custom.hasOwnProperty('show_price') &&
    //   boostPFSConfig.custom.show_price) {
    html = '<p class="boost-pfs-filter-product-item-price">';

    var priceMin = data.price_min;
    var compareAtPriceMin = data.compare_at_price_min;
    var sizeGroups = getSizeGroup(data) || [];
    var preparedData = getPreparedData(data, sizeGroups, true) || {};
    var availableSizeGroups = preparedData.availableSizeGroups || [];
    var prices = preparedData.prices || {};

    if (priceVaries && sizeGroups.length > 1) {
      if (availableSizeGroups.length > 0) {
        if (
          availableSizeGroups[0] !== sizeGroups[0] &&
          prices[availableSizeGroups[0]].compare_at_price !== compareAtPriceMin
        ) {
          compareAtPriceMin = prices[availableSizeGroups[0]].compare_at_price;
        }
        if (
          availableSizeGroups[0] !== sizeGroups[0] &&
          prices[availableSizeGroups[0]].price !== priceMin
        ) {
          priceMin = prices[availableSizeGroups[0]].price;
        }
      }
    }

    if (priceVaries && availableSizeGroups.length > 1) {
      html += "<span>" + boostPFSConfig.label.from + " " + "</span>";
    }

    //logica omnibus
    const omnibusPrice = data?.metafields
      ?.filter((el) => el.namespace === "omnibus")
      .filter((el) => el.key === "bestPrice")?.[0];

    if (omnibusPrice && onSale) {
      const omnibusPriceValue = JSON.parse(omnibusPrice.value);
      if (parseFloat(omnibusPriceValue.amount) <= priceMin) {
        onSale = false;
      }
    }

    if (onSale) {
      html +=
        '<span class="boost-pfs-filter-product-item-sale-price grid-product__price--savings">' +
        Utils.formatMoney(priceMin) +
        "</span> ";

      if (omnibusPrice) {
        const omnibusPriceValue = JSON.parse(omnibusPrice.value);
        html += "<s>" + omnibusPriceValue.amount + "€</s> ";
        html += '<div id="omnibus-placeholder-' + data.handle + '"></div>';
        html +=
          '<script>onLoadOmnibusPrice("' +
          data.handle +
          '","' +
          omnibusPriceValue.amount +
          '")</script>';
      } else {
        html += "<s>" + Utils.formatMoney(compareAtPriceMin) + "</s> ";
      }

      // if (boostPFSConfig.custom.product_save_amount) {
      //   var savePrice = '';
      //   if (boostPFSConfig.custom.product_save_type == 'dollar') {
      //     savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      //   } else {
      //     savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
      //     savePrice += '%';
      //   }
      //   var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
      //   html += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
      // }
    } else {
      html +=
        '<span class="boost-pfs-filter-product-item-regular-price">' +
        Utils.formatMoney(priceMin) +
        "</span>";
    }
    html += "</p>";
    // }
    return html;

    // var itemPriceHtml = '';
    // if (onSale) {
    //   itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
    //   itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_max) + '</span>';
    //   itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    // }
    // if (priceVaries) {
    //   itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
    // } else {
    //   // N. Ammendola - replaced min price with max price and set priceVaries always to false
    //   itemPriceHtml += Utils.formatMoney(data.price_max);
    // }
    // if (onSale && boostPFSConfig.custom.product_save_amount) {
    //   var savePrice = '';
    //   if (boostPFSConfig.custom.product_save_type == 'dollar') {
    //     savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
    //   } else {
    //     savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
    //     savePrice += '%';
    //   }
    //   var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
    //   itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    // }
    // itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  }

  function buildLabels(data) {
    onSale = isOnOmnibusSale(data, onSale);
    var customLabel = "";
    data.tags.forEach(function (tag) {
      if (tag.startsWith("_label_")) {
        if (!customLabel) {
          customLabel = tag.replace("_label_", "");
        }
      }
    });
    var itemLabelHtml = "";
    if (customLabel) {
      itemLabelHtml =
        '<div class="grid-product__tag grid-product__tag--custom">' +
        customLabel +
        "</div>";
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml =
          '<div class="grid-product__tag grid-product__tag--sold-out">' +
          boostPFSConfig.label.sold_out +
          "</div>";
      } else if (onSale) {
        itemLabelHtml =
          '<div class="grid-product__tag grid-product__tag--sale">' +
          boostPFSConfig.label.sale +
          "</div>";
      }
    }
    return itemLabelHtml;
  }

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;

    /*** Prepare data ***/
    data = prepareShopifyData(data);
    // var images = data.images_info;
    // // Displaying price base on the policy of Shopify, have to multiple by 100
    // var soldOut = !data.available; // Check a product is out of stock
    // var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    // var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";

    var saleClass = onSale ? boostPFSTemplate.saleClass : "";

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    itemHtml = itemHtml.replace(
      /{{grid_item_width}}/g,
      boostPFSConfig.custom.grid_item_width
    );
    itemHtml = itemHtml.replace(
      /{{products_per_row}}/g,
      boostPFSConfig.custom.products_per_row
    );

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add Product Data Attribute
    itemHtml = itemHtml.replace(
      /{{itemData}}/g,
      buildProductDataAttribute(data, this.index)
    );

    // // Add soldOut class
    // var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    // itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, buildLabels(data));

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? '<div class="grid-product__vendor">' + data.vendor + "</div>"
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    setTimeout(function () {
      jQuery(".boost-pfs-filter-option-value").each(function () {
        jQuery(this).text(jQuery(this).text().replace(/_/g, " "));
        jQuery(this).text(
          jQuery(this).text().replace("No age breakdown", "No age")
        );
        jQuery(this).text(jQuery(this).text().replace("Adult | ", ""));
        jQuery(this).text(jQuery(this).text().replace("Kid | ", ""));
        jQuery(this).text(jQuery(this).text().replace("Youth | ", ""));
        jQuery(this).text(jQuery(this).text().replace("Infant | ", ""));
        jQuery(this).text(jQuery(this).text().replace("XXXX", "4X"));
        jQuery(this).text(jQuery(this).text().replace("XXX", "3X"));
        jQuery(this).text(jQuery(this).text().replace("XX", "2X"));
        jQuery(this).text(
          jQuery(this).text().replace("FallWinter", "Fall/Winter")
        );
        jQuery(this).text(
          jQuery(this).text().replace("SpringSummer", "Spring/Summer")
        );
      });

      const queryString = window.location.search;
      const parameters = new URLSearchParams(queryString);
      if (parameters.get("pf_opt_size") != null) {
        let value = parameters.get("pf_opt_size");
        value = value.split(" | ");
        let size = value[1];
        size = size
          .replace("XXXX", "4X")
          .replace("XXX", "3X")
          .replace("XX", "2X");
        jQuery(".grid-product__quickadd-btn:not(.checked)").each(function () {
          if (jQuery(this).text() == size) {
            let variant_id = jQuery(this).attr("data-variant");
            jQuery(this).addClass("checked");
            let link = jQuery(this)
              .closest(".grid-product__meta")
              .prev(".grid-product__link ")
              .attr("href");
            jQuery(this)
              .closest(".grid-product__meta")
              .prev(".grid-product__link ")
              .attr("href", link + "?variant=" + variant_id);
          }
        });
      }
    }, 500);

    // Add Quick shop
    var size_of_array = 0;
    var itemQuickShopButtonHtml = "";
    data.options_with_values.forEach(function (option, option_index) {
      let option_name = option.name;

      if (option_name == "size") {
        for (variant in data.variants) {
          size_of_array = size_of_array + 1;
        }
      }
    });

    if (size_of_array > 1) {
      itemQuickShopButtonHtml = '<div class="grid-product__quickadd">';

      data.options_with_values.forEach(function (option, option_index) {
        let option_name = option.name;

        if (option_name == "size") {
          for (variant of data.variants) {
            let value = variant.options[option_index].split(" | ");
            let variant_class = "grid-product__quickadd-btn";
            if (variant.available == true) {
              variant_class += variant.available == true ? "" : " sold-out";
              if (value[0] == "Adult")
                itemQuickShopButtonHtml +=
                  '<button class="' +
                  variant_class +
                  '" data-variant="' +
                  variant.id +
                  '" js-quick-add data-tags="' +
                  data.tags.join(", ") +
                  '">' +
                  value[1]
                    .replace("XXXX", "4X")
                    .replace("XXX", "3X")
                    .replace("XX", "2X") +
                  "</button>";
            }
          }
        }
      });

      itemQuickShopButtonHtml += "</div>";
    }

    itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      var reviewHtml = "";
      if (boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml =
          '<span class="shopify-product-reviews-badge" data-id="' +
          data.id +
          '"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(
      /{{itemSwatchHoverImages}}/g,
      swatchHtml.itemSwatchHoverImages
    );

    var itemQuickShopModal = "";

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal =
        '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
        '<div class="modal__centered">' +
        '<div class="modal__centered-content">' +
        '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
        "</div>" +
        '<button type="button" class="modal__close js-modal-close text-link">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
        '<span class="icon__fallback-text">Close Modal</span>' +
        "</button>" +
        "</div>" +
        "</div>" +
        "</div>";
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);

    var sizeGroups = getSizeGroup(data);
    var availableSizeGroups = getPreparedData(data, sizeGroups);

    let product_size_group =
      "\n<span style='font-weight: 500; text-transform: capitalize;'>" +
      availableSizeGroups
        .map((g) => (g === "No age breakdown" ? "One size" : g))
        .join(" - ") +
      "</span>";

    let product_title = data.title;
    let product_title_split = product_title.split(" - ");

    if (product_title_split.length >= 1) {
      let product_title_first =
        "<strong>" + product_title_split[0] + "</strong>";
      let product_title_last =
        product_title_split[product_title_split.length - 1];
      product_title =
        product_title_first +
        "<span class='italic' >" +
        product_title_last.toLowerCase() +
        "</span>";
    } else {
      product_title = data.title;
    }
    product_title = product_title + product_size_group;
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replaceAll(/{{itemTitle}}/g, product_title);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = "";
    var itemSwatchHoverImagesHtml = "";
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (
          option_name.indexOf("color") != -1 ||
          option_name.indexOf("colour") != -1
        ) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function (variant) {
            var value = variant.merged_options[option_index].split(":")[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(
                boostPFSAppConfig.general.file_url.replace(
                  "/?",
                  "/" + colorValueSlugify + ".png?"
                ),
                "50x"
              );
              var variantImage = Utils.optimizeImage(variant.image, "400x");

              var swatchItem =
                '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                "</a>";

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(
                /{{colorValueSlugify}}/g,
                colorValueSlugify
              );
              swatchItem = swatchItem.replace(
                /{{swatchClass}}/g,
                variant.image ? "color-swatch--with-image" : ""
              );
              swatchItem = swatchItem.replace(
                /{{variantImage}}/g,
                variantImage
              );
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(
                /{{backgroundColor}}/g,
                colorValueSlugify.split("-").pop()
              );

              var swatchHoverImage =
                '<div class="grid-product__color-image grid-product__color-image--' +
                variant.id +
                ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml =
          ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' +
          swatchItems.join("") +
          "</div>";
        itemSwatchHoverImagesHtml = swatchHoverImages.join("");
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml,
    };
  }

  function buildProductDataAttribute(data, index) {
    var sku = data.skus[0];
    var tags = data.tags;
    var gender = tags
      .filter((t) => t.substring(0, 2) === "g_")
      ?.map((t) => t.split("g_")[1])
      .join(", ");
    var styleGroup = tags
      .find((t) => t.substring(0, 4) === "stg_")
      ?.split("stg_")[1];
    var styleDescripton = tags
      .find((t) => t.substring(0, 4) === "std_")
      ?.split("std_")[1];
    var colorFamily = tags
      .find((t) => t.substring(0, 3) === "cf_")
      ?.split("cf_")[1];
    var label = tags
      .find((t) => t.substring(0, 4) === "lbl_")
      ?.split("lbl_")[1];
    var category = tags
      .find((t) => t.substring(0, 4) === "cat_")
      ?.split("cat_")[1];
    var attributes = `
      data-item_id="${data.skus[0]}"
      data-item_name="${data.title}"
      data-item_category="${sku.substring(0, 7)}_${data.title.split(" - ")[0]}"
      data-item_category2="${gender}"
      data-item_category3="${styleGroup}_${styleDescripton}"
      data-item_category4="${colorFamily}_${sku.substring(10, 13)}"
      data-item_category5="${
        data.options_with_values[0]?.values[0]?.title.split(" | ")[0]
      }_${sku.substring(13, 19)}"
      data-item_brand="Superga_${label}"
      data-item_color_code="${sku.substring(10, 13)}"
      data-item_size_code="${sku.substring(13, 19)}"
      data-item_team_code="${sku.substring(7, 10)}"
      data-item_category_basic="${category}"
      data-item_color_family="${colorFamily}"
      data-item_size_group="${
        data.options_with_values[0]?.values[0]?.title.split(" | ")[0]
      }"
      data-item_style_group="${styleGroup}"
      data-item_full_price="${data.compare_at_price_min}"
      data-item_discount_percent="${data.percent_sale_min}"
      data-discount="${data.compare_at_price_min - data.price_min}"
      data-price="${data.price_min}"
      data-item_position="${index + 1}"
    `;

    return attributes;
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = "";
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? boostPFSTemplate.previousActiveHtml
          : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? boostPFSTemplate.nextActiveHtml
          : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return "";
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      html = boostPFSTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
    if (window.pushImpressions) {
      window.pushImpressions(data);
    }
    // Hover color swatch
    onColorSwatchHover();
  };

  function onColorSwatchHover() {
    document.querySelectorAll(".color-swatch--with-image").forEach((swatch) => {
      swatch.addEventListener("mouseenter", function () {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector(".grid-product__color-image--" + id);
        el.style.backgroundImage = "url(" + image + ")";
        el.classList.add("is-active");
      });
      swatch.addEventListener("mouseleave", function () {
        var id = swatch.dataset.variantId;
        document
          .querySelector(".grid-product__color-image--" + id)
          .classList.remove("is-active");
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function () {
      if (typeof theme !== null && window.theme) {
        if (typeof AOS != "undefined" && typeof AOS.refreshHard == "function") {
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == "function") {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == "function") {
          $(window).off("popstate");
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      // jQ('.js-drawer-open-collection-filters').on('click', function() {
      //   jQ('.' + Class.filterOption).each(function() {
      //     var showMoreType = jQ(this).data('show-more-type');
      //     if (showMoreType && jQ(this).data('display-type') != 'range') {
      //       self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
      //     }
      //   });
      // });
    });
    // Add modal container for quickview
    var isReinitQuickview =
      !isFirstLoad ||
      Utils.isSearchPage() ||
      Globals.queryParams.hasOwnProperty("_");
    if (
      !Utils.isMobile() &&
      boostPFSConfig.custom.quick_shop_enable &&
      isReinitQuickview
    ) {
      jQ(".boost-pfs-quick-shop-modal-container").html("");
      if (data.products.length > 0) {
        data.products.forEach(function (product) {
          // var quickUrl = Utils.buildProductItemUrl(product);
          var quickUrl =
            Utils.buildProductItemUrl(product) + "?view=boost-pfs-quickview";
          jQ.ajax({
            url: quickUrl,
            success: function (result) {
              numberQuickViewModalLoaded++;
              jQ(".boost-pfs-quick-shop-modal-container").append(result);
              if (numberQuickViewModalLoaded == data.products.length) {
                theme.collapsibles.init();
                numberQuickViewModalLoaded = 0;
                jQ(".quick-product__btn").removeClass("bc-hide");
              }
            },
          });
        });
      }
    }

    // Build total products text
    var totalProductText = "";
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(
        /{{ count }}/g,
        data.total_product
      );
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(
        /{{ count }}/g,
        data.total_product
      );
    }
    jQ(".boost-pfs-filter-total-product").html(totalProductText);

    // Build filter button text on mobile
    // var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    // if (numSelectedFilter) {
    //   jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    // } else {
    //   jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    // }
    theme.initQuickShop();
  };
})();
